// 語言切換、登入按鈕
'use client';

import { useSelector } from 'react-redux';
import { userState } from '@/slices/userSlice';

import UserFunction from './header/UserFunction'; // 語言切換、收藏、通知、頭像、登入註冊按鈕

const FunctionWrapper = () => {
    // 判斷是否為分類列表路徑
    const { user } = useSelector(userState);

    return (
        <div className="flex items-center gap-x-[10px]">
            {/* 語言切換、收藏、通知、頭像、登入註冊按鈕 */}
            <UserFunction user={user} />
        </div>
    );
};

export default FunctionWrapper;
